module.exports = __webpack_public_path__ + "static/horizons04-8567cf8fb502827c8ad1427ff65c6876.png";